import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";
import { Modal } from "./Modal.js";

export class SeeDetails {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAtt = "see-details";
    }

    init() {
        this.seeDetailsModal = new Modal(this.app, "see-details", this.getHtml(), null, "details-class");
        this.seeDetailsModal.init();

        this.eventHandlers();
    }

    eventHandlers() {
        var $this = this;
    }

    updateVehicleInformation() {
        DOMHelper.setAttribute(this.getSelector(".vehicle-image img"), "src", this.app.config.vehicle.imgUrl);
        DOMHelper.setInnerHTML(this.getSelector(".payment-vehiclename"), this.app.config.vehicle.label);
    }

    updateValues(data, creditScore, dealType, msrp, vehicleData) {
        // let infoPayment = document.querySelector(this.getSelector(".vehicle-info"));
        // infoPayment.innerHTML = vehicleData.infoPayment.innerHTML;

        // Only the value spans are written — replacing the whole .cashdown/.msrp line with plain
        // text dropped the summary-item-label/value spans the label-left/value-right layout needs.
        let cashDownText = FormatHelper.currencyFormat(0, 0);
        if (dealType != "cash") {
            cashDownText = "-" + FormatHelper.currencyFormat(data.downPayment - (data.tradeIn||0), 0);
        }
        let accValue = this.app.dealPage.accessoriesValue;

        DOMHelper.setInnerHTML(this.getSelector(".cashdown .deal-cash-down"), cashDownText);

        DOMHelper.setInnerHTML(this.getSelector(".msrp .msrp-value"), FormatHelper.currencyFormat(msrp, 0));
        if (dealType == "cash") {
            document.querySelector(this.getSelector(".credit-score-lease")).style.display = "none";
        } else {
            document.querySelector(this.getSelector(".credit-score-lease")).style.display = "block";
            DOMHelper.setInnerHTML(
                this.getSelector(".credit-score"),
                creditScore.options[creditScore.selectedIndex].text
            );
        }

        var disclaimerText = this.app.getDisclaimerText(dealType);
        DOMHelper.setInnerHTML(this.getSelector(".trade-in-header"), "$" + data.tradeIn);
        DOMHelper.setInnerHTML(this.app.getSelector(".summary-disclaimer-content"), disclaimerText);//it includes the payment section one
        DOMHelper.setInnerHTML(this.getSelector(".mypayment-accesories-value"), FormatHelper.currencyFormat(accValue));
    }

    updateCashValues(msrp) {
        console.log("calling see details cash values");
        let elem = document.querySelector(this.getSelector(".vehicle-lease-type"));
        console.log(elem);
        document.querySelector(this.getSelector(".vehicle-lease-type")).innerHTML = "Cash for $" + msrp;
    }

    hideTradeInValueInformation() {
        let tradeInType = this.app.siteSettings.tradeInType ?? "manual";
        if (tradeInType != "manual") {
            DOMHelper.addClass(document.querySelector(this.getSelector(".trade-in-value-field")), "d-none");
        }
    }

    getHtml() {
        return `<div class="see-details payment-summary-section">
    <div class="vehicle-image">
        <img src="https://images.otf3.pixelmotiondemo.com/QsSVt-20230104160441.png" alt="vehicle image">
    </div>
    <div class="payment-vehiclename">--</div>
    <div class="payment-option">--</div>
    <div class="mypayment-value">$--/mo</div>
    <div class="payment-description">plus tax for <span class="mypayment-months-value">--</span> months and a single payment for $--</div>
    <!-- <div class="summary-details">
        <div class="summary-label">Summary</div>
        <div class="summary-item msrp">MSRP: $10,490</div>
        <div class="summary-item discounts d-none"></div>
        <div class="summary-item dealer-markups d-none"></div>
        <div class="summary-item summary-item-incentives d-none">Incentives: -<span class="incentives-value">$0.00</span></div>
        <div class="summary-item taxes d-none">Taxes: </div>
        <div class="summary-item cashdown">Cash Down: <span class="deal-cash-down">-$1,000</span></div>
        <div class="summary-item customercash d-none">Customer Cash: <span class="customer-cash">-$1,000</span></div>
        <div class="summary-item accessories">Accessories: <span class="mypayment-accesories-value"></span></div>
        <div class="summary-item trade-in-value trade-in-value-field">Trade-In Value: <span class="mypayment-trade-in-value">$0.00</span></div>
        <div class="summary-item summary-item-coffers d-none">Conditional Offers: <span class="coffers-value">$0.00</span></div>
        <div class="summary-item final">Final Price: <span class="final-price-value"></span> </div>
        <div class="summary-item apr">APR: <span class="deal-apr">8%</span></div>
    </div> -->
    <!-- DEFAULT: Finance / Cash / Balloon -->
<div class="summary-details summary-details-default">
    <div class="summary-label">Summary</div>
    <!-- Populated instead of the fixed slots below when a payment carries paymentData.priceStack
         (currently PmRates sites that opt in via pm-motors-api, e.g. lampedodge) -->
    <div class="summary-item price-stack d-none"></div>
    <div class="summary-item msrp"><span class="summary-item-label">MSRP:</span> <span class="msrp-value">$--</span></div>
    <div class="summary-item discounts d-none"></div>
    <div class="summary-item dealer-markups d-none"></div>
    <div class="summary-item summary-item-incentives d-none"><span class="summary-item-label">Incentives:</span> <span class="summary-item-value">-<span class="incentives-value">$--</span></span></div>
    <div class="summary-item taxes d-none">Taxes: </div>
    <div class="summary-item net-price d-none"><span class="summary-item-label">Net Price:</span> <span class="net-price-value">$--</span></div>
    <div class="summary-item cashdown"><span class="summary-item-label">Cash Down:</span> <span class="deal-cash-down">-$--</span></div>
    <div class="summary-item customercash d-none"><span class="summary-item-label">Customer Cash:</span> <span class="customer-cash">-$--</span></div>
    <div class="summary-item accessories d-none"><span class="summary-item-label">Accessories:</span> <span class="mypayment-accesories-value"></span></div>
    <div class="summary-item trade-in-value trade-in-value-field d-none"><span class="summary-item-label">Trade-In Value:</span> <span class="mypayment-trade-in-value">$--</span></div>
    <div class="summary-item summary-item-coffers d-none"><span class="summary-item-label">Conditional Offers:</span> <span class="summary-item-value">-<span class="coffers-value">$--</span></span></div>
    <!-- Shown before Final Price/Amount Financed since it's now folded into that total (a
         mandatory fee, not an optional add-on) — matches the dealer's own price stack, which
         lists Doc/EFF/PTA fee before its "Best Price" line for the same reason. -->
    <div class="summary-item finance-doc-fee d-none"><span class="finance-doc-fee-label">Doc Fee:</span> <span class="finance-doc-fee-value">$--</span></div>
    <div class="summary-item final"><span class="summary-item-label final-label">Final Price:</span> <span class="final-price-value"></span></div>
    <div class="summary-item apr"><span class="summary-item-label">APR:</span> <span class="deal-apr">8%</span></div>
    <div class="summary-item finance-gov-fees d-none"><span class="summary-item-label">Government Fees:</span> <span class="finance-gov-fees-value">$--</span></div>
</div>

<!-- LEASE -->
<div class="summary-details summary-details-lease d-none">
    <div class="summary-group summary-group-monthly-payment">
        <div class="summary-group-label">Monthly Payment</div>
        <div class="summary-item lease-base-payment"><span class="summary-item-label">Base Payment:</span> <span class="lease-base-payment-value">$--</span></div>
        <div class="summary-item lease-monthly-taxes d-none"><span class="summary-item-label">Monthly Fees and Taxes:</span> <span class="lease-monthly-taxes-value">$--</span></div>
        <div class="summary-item lease-total-monthly d-none"><span class="summary-item-label">Total Monthly Payment:</span> <span class="lease-total-monthly-value">$--</span></div>
    </div>

    <div class="summary-group summary-group-due-signing">
        <div class="summary-group-label">Due at Signing</div>
        <div class="summary-item lease-cashdown"><span class="summary-item-label">Cash Down:</span> <span class="lease-cashdown-value">$--</span></div>
        <div class="summary-item lease-trade-in d-none"><span class="summary-item-label">Trade In:</span> <span class="lease-trade-in-value">$--</span></div>
        <div class="summary-item lease-trade-in-owed d-none"><span class="summary-item-label">Trade-in balance owed:</span> <span class="summary-item-value">(<span class="lease-trade-in-owed-value">$--</span>)</span></div>
        <div class="summary-item lease-doc-fee d-none"><span class="lease-doc-fee-label">Doc Fee:</span> <span class="lease-doc-fee-value">$--</span></div>
        <div class="summary-item lease-taxes d-none"><span class="summary-item-label">Taxes:</span> <span class="lease-taxes-value">$--</span></div>
        <div class="summary-item lease-gov-fees d-none"><span class="summary-item-label">Government Fees:</span> <span class="lease-gov-fees-value">$--</span></div>
        <div class="summary-item lease-total-due"><span class="summary-item-label">Total Due at Signing:</span> <span class="lease-total-due-value">$--</span></div>
    </div>
</div>

    
    <div class="d-none vehicle-info"></div>
    <p class="d-none vehicle-lease credit-score-lease" style="font-weight: 700;">Credit Score: <span class="credit-score" style="font-weight: 400;"></span></p>    
    <p class="d-none vehicle-lease" style="font-weight: 700;">Trade In Value: <span class="trade-in-header" style="font-weight: 400;"></p>

    <div class="summary-disclaimer">Estimated payments exclude applicable taxes, title, registration, license, and documentary fees, and will vary depending upon the final price and terms agreed upon between you and your Dealer.</div>

    <div class="submit-button-close drs-close-modal-btn" data-modal="modalSeeDetails">Close</div>
</div>

 <!-- <div class="start-see-details-modal" style="margin-top: 1rem;">
    <figure>
        <img src="" alt="vehicle-image" class="image-vehicle">
    </figure>
    <p class="vehicle-details-name"></p>
    <div class="vehicle-info"></div>
    <hr>
    <p class="vehicle-lease" style="font-weight: 700;">MSRP: <span class="msrp-header" style="font-weight: 400;"></span></p>
    <p class="vehicle-lease" style="font-weight: 700;">Cash Down: <span class="downpayment-header" style="font-weight: 400;"></span></p>
    <p class="vehicle-lease" style="font-weight: 700;">Accessories: <span class="accessories-header" style="font-weight: 400;">$0</span></p>
    <p class="vehicle-lease" style="font-weight: 700;">Trade-In Value: <span class="tradeinvalue-header" style="font-weight: 400;">$0</span></p>
</div> -->
`;
    }

    getSelector(selector) {
        return this.app.getSelector("." + this.classAtt + " " + selector);
    }
}
